module.exports = __webpack_public_path__ + "images/mobile/img-dingtalk-browser-70658672bfa81189d5c6e6e7c7404614.png";